__turbopack_context__.v({
  "heroButton": "styles-module__aeVZ_G__heroButton",
});
